








import { Component, Prop, Vue } from 'vue-property-decorator'
import Button from '@/components/atoms/Button.vue'

@Component({
  components: { Button }
})

export default class HelloWorld extends Vue {
  @Prop() private msg!: string;
}
